import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApplications, updateApplicationStatus } from '../../redux/slices/applicationsSlice';
import TableHelper from '../Shared/TableHelper';
import { toast } from 'react-toastify';
import './ApplicationsList.css';

const ApplicationsList = () => {
  const dispatch = useDispatch();
  const { items, error } = useSelector((state) => state.applications);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');

  const statuses = ['En revisión', 'Aceptada', 'Entrevista', 'Contratada', 'Rechazada'];

  useEffect(() => {
    dispatch(fetchApplications({ q: search, filter }));
  }, [search, filter, dispatch]);

  const handleStatusChange = (applicationId, newStatus) => {
    dispatch(updateApplicationStatus({ applicationId, status: newStatus })).unwrap().then(() => {
      toast.success(`Candidatura actualizada a "${newStatus}"`);
    }).catch((err) => {
      toast.error(err || 'Error al actualizar el estado');
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Profesional',
        accessor: 'candidate_name',
        Cell: ({ value }) => <strong>{value}</strong>,
      },
      {
        Header: 'Oferta',
        accessor: 'title',
      },
      {
        Header: 'Empresa',
        accessor: 'company',
      },
      {
        Header: 'Fecha',
        accessor: 'created_at',
        Cell: ({ value }) => new Date(value).toLocaleDateString('es-ES'),
      },
      {
        Header: 'Estado',
        accessor: 'status',
        Cell: ({ row: { original: app } }) => (
          <select
            value={app.status}
            onChange={(e) => handleStatusChange(app.id, e.target.value)}
            className="status-select"
          >
            {statuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        ),
      },
      {
        Header: 'Chat',
        accessor: 'conversation_id',
        Cell: ({ value }) => (
          <span className={`badge ${value ? 'active' : ''}`}>
            {value ? 'Habilitado' : 'Sin chat'}
          </span>
        ),
      },
    ],
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <div className="applications-container">
      <div className="applications-header">
        <h1>Candidaturas</h1>
        <p>Controla el embudo completo de selección.</p>
      </div>

      <div className="applications-toolbar">
        <input
          type="text"
          placeholder="Filtrar por candidato, oferta o empresa..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="filter-select">
          <option value="">Todos los estados</option>
          {statuses.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="applications-table-container">
        <TableHelper columns={columns} data={items} exportFileName="candidaturas" />
      </div>
    </div>
  );
};

export default ApplicationsList;
